import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Elise Marlowe",
    tagline: "Interior design journal",
    description: "Interior designer Elise Marlowe writes about warm, lived-in homes: layered living rooms, kitchens built for real life, calm bedrooms, color and the materials that make a house feel like yours.",
    url: getOrigin(),
    ogImage: 'https://elise-marlowe-interiors.cdn.modulify.website/journal/the-layered-living-room.jpg'
}

export const siteImages = {
    portrait: {
        src: 'https://elise-marlowe-interiors.cdn.modulify.website/site/reading-nook.jpg',
        alt: "Sunlit reading corner with a velvet armchair, a terracotta throw and floor-to-ceiling bookshelves"
    }
}

export const mainNav = [
    { label: "Journal", href: '/journal' },
    { label: "About", href: '/about' },
    { label: "Contact", href: '/contact' }
]
